"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzTypographie = exports.getWeight = exports.SIZE = exports.VARIANTS = exports.TITLES_CAPS = exports.TITLES = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

exports.TITLES = ['h1', 'h2', 'h3', 'h4', 'h5'];
exports.TITLES_CAPS = exports.TITLES.map(function (t) {
  return t.toUpperCase();
});
exports.VARIANTS = __spread(exports.TITLES, exports.TITLES_CAPS, ['highlight', 'button', 'huge', 'large', 'body', 'caption']);
exports.SIZE = ['S', 'M', 'L', 'XL'];

exports.getWeight = function (params) {
  var size = params.size,
      weight = params.weight,
      variant = params.variant;

  var checkSizeAndVariant = function checkSizeAndVariant(equalVariant, sizes) {
    var isVariantEqual = variant === equalVariant;
    var isSizeIncluded = !sizes || sizes.includes(size);
    return isVariantEqual && (!size || isSizeIncluded);
  };

  if (weight) {
    return weight;
  }

  switch (true) {
    case checkSizeAndVariant('highlight'):
    case checkSizeAndVariant('H1', ['S', 'L', 'XL']):
    case checkSizeAndVariant('H2', ['S', 'M', 'L']):
    case checkSizeAndVariant('H3', ['L']):
    case checkSizeAndVariant('H4', ['M', 'L']):
    case checkSizeAndVariant('H5', ['L']):
    case checkSizeAndVariant('button', ['S']):
      return 'bold';

    case checkSizeAndVariant('huge'):
    case checkSizeAndVariant('large'):
    case checkSizeAndVariant('H2', ['XL']):
    case checkSizeAndVariant('H3', ['XL']):
    case checkSizeAndVariant('H5', ['XL']):
    case checkSizeAndVariant('button', ['M', 'L']):
    case checkSizeAndVariant('caption', ['M', 'L']):
      return 'medium';

    case checkSizeAndVariant('H1', ['M']):
    case checkSizeAndVariant('H3', ['M']):
    case checkSizeAndVariant('body', ['S', 'M', 'L', 'XL']):
    case !weight:
    default:
      return 'regular';
  }
}; // Caption et button à vérifier


exports.SzTypographie = function (_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'body' : _b,
      weight = _a.weight,
      color = _a.color,
      align = _a.align,
      className = _a.className,
      children = _a.children,
      tag = _a.tag,
      size = _a.size;
  var brandColors = ['primary', 'dark', 'light'];
  var defaultColor = brandColors.includes(color) ? 'text-primary-' : 'text-';
  var colorClassname = defaultColor + (color === 'primary' ? 'brand' : color);
  var alignClassname = "text-" + align;
  var fontFamily = exports.getWeight({
    variant: variant,
    weight: weight,
    size: size
  });
  var textClasses = classnames_1.default({
    huge: variant === 'huge',
    large: variant === 'large',
    'sz-typo-h1': variant === 'H1',
    'sz-typo-h2': variant === 'H2',
    'sz-typo-h3': variant === 'H3',
    'sz-typo-h4': variant === 'H4',
    'sz-typo-h5': variant === 'H5',
    'sz-typo-body': variant === 'body',
    'sz-typo-button': variant === 'button',
    'sz-typo-highlight': variant === 'highlight',
    'sz-typo-caption d-block ': variant === 'caption',
    sm: size === 'S',
    md: size === 'M',
    lg: size === 'L',
    xl: size === 'XL',
    'font-family-black': fontFamily === 'black',
    'font-family-bold': fontFamily === 'bold',
    'font-family-medium': fontFamily === 'medium',
    'font-family-regular': fontFamily === 'regular',
    'font-family-light': fontFamily === 'light'
  }, align && alignClassname, color && colorClassname, className);

  var setTag = function setTag() {
    if (tag) {
      return tag;
    } else if (exports.TITLES.includes(variant)) {
      return variant;
    } else if (exports.TITLES_CAPS.includes(variant)) {
      return variant.toLowerCase();
    } else {
      switch (variant) {
        case 'caption':
        case 'button':
          return 'span';

        case 'h1':
          return 'h1';

        case 'h2':
          return 'h2';

        case 'highlight':
        case 'huge':
        case 'large':
        case 'body':
        case 'text':
        default:
          return 'p';
      }
    }
  };

  var Tag = setTag();
  return react_1.default.createElement(Tag, {
    className: textClasses
  }, children);
};

exports.default = exports.SzTypographie;